/**
 * Well-known Firestore UID for the virtual "Double Bagel" support entity.
 * This document lives at users/DOUBLE_BAGEL_UID and is created by
 * scripts/createDoubleBagelFixture.js.
 *
 * Every player/coach gets a pinned conversation with this UID on signup.
 * Support users operate through this identity when responding to players/coaches.
 * System messages sent to conversations also use this UID as their sender.
 */
export const DOUBLE_BAGEL_UID = 'double-bagel-support';

export const DOUBLE_BAGEL_NAME = 'Double Bagel';

/**
 * Lessons threshold below which the lesson-count stat is hidden.
 *
 * One value for every surface in this app — discovery, the public coach
 * profile, and a coach's own profile. Previously each site carried its own
 * literal (5, 5, 30), so a coach's own profile disagreed with what players saw.
 *
 * The count itself is derived at read time from a coach's orders; see
 * `services/coachLessonCounts.ts`. Nothing writes
 * `coachProfile.completedLessonsCount`, and nothing ever has.
 */
export const MIN_LESSONS_TO_SHOW = 3;
